import JobSeekerManagement from './JobSeekerList';

export default JobSeekerManagement;